export const environment = {
  env: 'pre',
  API_CONTEXT: '',
  idpUrl:
    'https://pre-icars-mygarage-idp.auth.eu-central-1.amazoncognito.com/oauth2/authorize?client_id=4rttg8kif8l97nbljqcuucd5ql&response_type=code&scope=email+openid+phone+profile&redirect_uri=https%3A%2F%2Fwww.pre.mygarage.com.es%2Fregister%2Fmfa-authentication',
  pccDomain: 'https://cc-api-qa.seat.com/',
  websocketUrl:
    'wss://order-service.pre.mygarage.seat.cloud.vwgroup.com/websocket/configuration?id=',
  leasingPccUrl:
    'https://cc-api-qa.seat.com/seat-cc/configurator/LIVE/003/LEASING/es/car-selector',
  secretHashKey:
    'b94cfa856d23f0e759b6fa46748b47ad9f302438aaa1f3408c00539a3510fdaf'
};
